export default __webpack_public_path__ + "static/media/prev-Marine-Receiver-5.aaccf1c2.png";